var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95898 2.29175V17.7084H16.0423V4.8423L13.4918 2.29175H3.95898ZM2.70898 2.16675C2.70898 1.54543 3.21267 1.04175 3.83398 1.04175H13.5435C13.8419 1.04175 14.1281 1.16027 14.339 1.37125L16.9628 3.99503C17.1738 4.20601 17.2923 4.49215 17.2923 4.79052V17.8334C17.2923 18.4547 16.7886 18.9584 16.1673 18.9584H3.83398C3.21266 18.9584 2.70898 18.4547 2.70898 17.8334V2.16675Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 8.33342C6.04232 7.98824 6.32214 7.70842 6.66732 7.70842L13.334 7.70842C13.6792 7.70842 13.959 7.98824 13.959 8.33342C13.959 8.67859 13.6792 8.95842 13.334 8.95842L6.66732 8.95842C6.32214 8.95842 6.04232 8.67859 6.04232 8.33342Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 15.0001C6.04232 14.6549 6.32214 14.3751 6.66732 14.3751H13.334C13.6792 14.3751 13.959 14.6549 13.959 15.0001C13.959 15.3453 13.6792 15.6251 13.334 15.6251H6.66732C6.32214 15.6251 6.04232 15.3453 6.04232 15.0001Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 11.6667C6.04232 11.3216 6.32214 11.0417 6.66732 11.0417H10.0007C10.3458 11.0417 10.6257 11.3216 10.6257 11.6667C10.6257 12.0119 10.3458 12.2917 10.0007 12.2917H6.66732C6.32214 12.2917 6.04232 12.0119 6.04232 11.6667Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 1.04175C13.6792 1.04175 13.959 1.32157 13.959 1.66675V4.37508H16.6673C17.0125 4.37508 17.2923 4.6549 17.2923 5.00008C17.2923 5.34526 17.0125 5.62508 16.6673 5.62508H13.834C13.2127 5.62508 12.709 5.1214 12.709 4.50008V1.66675C12.709 1.32157 12.9888 1.04175 13.334 1.04175Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.440c889291558938b548e7470661c474.svg";
export { ForwardRef as ReactComponent };